import { LitElement, css, html } from "lit";
//#region src/pd-panel-viewer/PdPanel.ts
/**
* @tagname pd-panel
*
* @slot - Default slot for panel content.
*
* @cssprop --pd-panel-bg - Panel background (color, gradient, or `url(...)`). Default: `#afc1d2`.
* @cssprop --pd-panel-bg-size - CSS background-size. Default: `cover`.
* @cssprop --pd-panel-bg-position - CSS background-position. Default: `center`.
* @cssprop --pd-panel-bg-repeat - CSS background-repeat. Default: `no-repeat`.
* @cssprop --pd-panel-bg-attachment - CSS background-attachment. Default: `scroll`.
* @cssprop --pd-panel-border-radius - Panel border radius. Default: `0.2em`.
* @cssprop --pd-panel-padding - Content padding. Default: `2rem`.
*
* @attr {boolean} no-padding - Remove content padding (useful for full-bleed slides).
*/
var PdPanel = class extends LitElement {
	static {
		this.styles = css`
    :host {
      background: var(--pd-panel-bg, #afc1d2);
      background-size: var(--pd-panel-bg-size, cover);
      background-position: var(--pd-panel-bg-position, center);
      background-repeat: var(--pd-panel-bg-repeat, no-repeat);
      background-attachment: var(--pd-panel-bg-attachment, scroll);
      border-radius: var(--pd-panel-border-radius, 0.2em);
    }

    /* Default styles for content */
    #content {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      padding: var(--pd-panel-padding, 2rem);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
    }

    :host([no-padding]) #content {
      padding: 0;
    }

    #content > slot::slotted(*) {
      margin: 0;
    }
  `;
	}
	render() {
		return html`
      <div id="content">
        <slot></slot>
      </div>
    `;
	}
};
//#endregion
export { PdPanel };
